import { InjectedConnector } from "@web3-react/injected-connector";
import { WalletConnectConnector } from "@web3-react/walletconnect-connector";
import { WalletLinkConnector } from "@web3-react/walletlink-connector";
import LedgerHQFrameConnector from "web3-ledgerhq-frame-connector";
import { CHAINID, isDevelopment, allChainIds } from "./env";
export var injectedConnector = new InjectedConnector({
    // supportedChainIds,
    supportedChainIds: allChainIds,
});
// Only receive messages from platform.apps.ledger.com
export var ledgerConnector = new LedgerHQFrameConnector({
    targetOrigin: "https://platform.apps.ledger.com",
});
/**
 * A bug causes wallet connect connector to stuck forever upon second invoke
 * Possibly workaround as getting new connector after every connect
 * More about issue: https://github.com/NoahZinsmeister/web3-react/pull/130
 */
export var getWalletConnectConnector = function () {
    var _a, _b;
    return new WalletConnectConnector({
        // supportedChainIds,
        supportedChainIds: allChainIds,
        rpc: isDevelopment()
            ? (_a = {},
                _a[CHAINID.BSC_TEST] = process.env.REACT_APP_BSC_TEST_URI || "",
                _a) : (_b = {},
            _b[CHAINID.BSC_MAINNET] = process.env.REACT_APP_BSC_MAINNET_URI || "",
            _b),
        qrcode: true,
        pollingInterval: 5000,
    });
};
export var walletlinkConnector = new WalletLinkConnector({
    url: (isDevelopment()
        ? process.env.REACT_APP_BSC_TEST_URI
        : process.env.REACT_APP_BSC_MAINNET_URI),
    appName: "Coda Finance",
    // supportedChainIds,
    supportedChainIds: allChainIds,
});
//# sourceMappingURL=connectors.js.map